const option = [
    { id: '1', name: 'ถามหาสินค้าประเภทยางรถยนต์' },
    { id: '2', name: 'ถามหาสินค้าประเภทอื่นๆ' },
    { id: '3', name: 'สอบถามบริการเกี่ยวกับการตรวจสภาพรถ' },
    { id: '0', name: 'อื่นๆ' }
]

const method = {
    getValueByKey(id) {
        return option.find(x => x.id === id).name;
    }
}

export default {
    option: option,
    service: method
};